import {useStripe} from "@stripe/react-stripe-js";
import axios from "axios";
import {PaymentIntentResult} from "@stripe/stripe-js";

export interface UsePaymentWithCardBody {
    amount: number,
    cardId: string,
    customerId?: string,
    description: string,
    country: string,
}

export const usePaymentWithCard = (): (body: UsePaymentWithCardBody, onSuccess: (id: string) => void, onError: (err: string) => void) => void => {
    const stripe = useStripe()
    return (body: UsePaymentWithCardBody, onSuccess: (res?: any) => void, onError: (err: string) => void) => {
        if(body.amount > 0) {
            axios.post(`${process.env.REACT_APP_BART_URL}/stripe/create-payment`, body)
                .then(res => {
                    if (
                        res.data.status === 'requires_action' &&
                        res.data.nextAction &&
                        res.data.nextActionType === 'use_stripe_sdk'
                    ) {
                        // send the authentication request for 3d secure cards
                        stripe?.confirmCardPayment(res.data.clientSecret)
                            .then((response: PaymentIntentResult) => {
                                if(response.error) {
                                    onError(response.error.message || "Un soucis est survenu, merci d'essayer une autre carte")
                                } else {
                                    onSuccess(response.paymentIntent.id);
                                }
                            })
                            .catch(() => {
                                onError("Un soucis est survenu, merci d'essayer une autre carte")
                            });
                    } else if(res.data.error) {
                        onError(res.data.error.message || "Un soucis est survenu, merci d'essayer une autre carte")
                    } else {
                        onSuccess(res.data.id);
                    }
                })
                .catch(error => {
                    onError(error.response.data.message)
                });
        } else {
            onSuccess('')
        }
    };

}
